import { render } from "./SignatureModal.vue?vue&type=template&id=23828858"
import script from "./SignatureModal.vue?vue&type=script&lang=js"
export * from "./SignatureModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__